import { CheckBox as GrommetCheckbox } from 'grommet'
import styled from 'styled-components'

const StyledCheckbox = styled(GrommetCheckbox)`
`

export { StyledCheckbox }
